<template>
  <form
    class="callback-form callbackwidget-call-form"
    novalidate
    @submit.prevent="submitThis"
    :class="[device_platform, { horizontal: horizontal }, form_class]"
  >
    <div class="callback-form__container">
      <div class="callback-form__input-wrapper">
        <input
          name="tel"
          type="tel"
          class="callback-form__input"
          :class="[input_theme]"
          placeholder="Телефон"
          v-model="phone"
          ref="phone"
          v-mask
          :pattern="'.*[0-9]{1}.*[0-9]{3}.*[0-9]{3}.*[0-9]{4}'"
          required
        />
      </div>

      <button
        type="submit"
        :disabled="!agreed"
        class="button callback-form__button"
        :class="[{ button_disabled: !agreed }, button_theme]"
        ref="submitter"
      >
        <span><slot></slot></span>
      </button>
    </div>

    <div class="agreement" v-if="CONSTANTS.need_agreement">
      <div class="agreement__checkbox">
        <checkbox v-model="acceptance_personal">
          <slot name="agreement">
            <span class="agreement__text">
              <a
                href="https://www.rolf.ru/agreement/"
                target="_blank"
                class="agreement__link"
                >Согласие</a
              >
              на обработку персональных данных*
            </span>
          </slot>
        </checkbox>
      </div>
      <div class="agreement__checkbox">
        <checkbox v-model="acceptance_communication">
          <slot name="agreement">
            <span class="agreement__text">
              <a
                href="https://www.rolf.ru/agreement/"
                target="_blank"
                class="agreement__link"
                >Согласие</a
              >
              на дальнейшую коммуникацию
            </span>
          </slot>
        </checkbox>
      </div>
    </div>
  </form>
</template>

<script>
import Mixin from "@/common/mixin";
import Mask from "@/common/mask";
import Checkbox from "../checkbox";

export default {
  name: "callback-input",
  components: { Checkbox },
  directives: { Mask },
  mixins: [Mixin],
  props: [
    "horizontal",
    "data",
    "form_class",
    "focusOnMount",
    "button_theme",
    "input_theme",
  ],
  data() {
    return {
      acceptance_personal: true,
      acceptance_communication: true,
      phone: "",
    };
  },
  computed: {
    agreed() {
      return this.acceptance_personal && this.acceptance_communication;
    },
  },
  mounted() {
    if (this.focusOnMount) {
      this.$refs.phone.focus();
    }
  },
  methods: {
    getAgreement(type) {
      this.$emit("getAgreement", type);
    },
    submitThis(event) {
      if (
        this.$refs.phone.validity.valueMissing ||
        !this.$refs.phone.validity.valid
      ) {
        this.$refs.phone.setCustomValidity("Введите номер телефона");
      }
      if (
        !this.$refs.phone.validity.valueMissing &&
        !this.$refs.phone.validity.patternMismatch
      ) {
        this.$refs.phone.setCustomValidity("");
      }
      if (this.agreed && this.$el.reportValidity()) {
        if (typeof ckForms !== "undefined") {
          ckForms.send(this.$el);
        }
        ym(48811595,'reachGoal','send_form');
        this.$emit("callBack", {
          phone: this.phone,
          data: this.data,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/constants.scss";

.mobile {
  .callback-form {
    &__container {
      align-items: center;
    }
  }

  &.contacts {
    .agreement {
      left: 0;
    }
  }
}

.callback-form {
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  &__input-wrapper {
    position: relative;
    width: 100%;

    &::after {
      content: url("../../images/utils/phone.svg");
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-45%);
    }
  }

  &__input {
    width: 100%;
    height: 52px;
    padding: 0 20px;
    text-align: left;
    font-size: 16px;
    color: #000;
    background-color: #fff;
    border: 1px solid #000;
    outline: none;

    &::placeholder {
      font-weight: 400;
      font-size: 15px;
      color: #828282;
      padding: 0;
      overflow: visible;
    }

    &.transparent {
      border: none;
      background-color: transparent;
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }

  &__button {
    margin-top: 20px;
    width: 100%;
    &_disabled {
      background: #c2c2c2;
      cursor: default;
    }
  }
}

.contacts-form {
  .agreement {
    &__text, &__link {
      color: #fff;
    }
  }
}

.agreement {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
  margin-top: 10px;

  &__checkbox {
    margin-top: 20px;
  }

  &__text {
    padding-left: 30px;
    font-size: 10px;
    text-align: left;
    // color: #bdbdbd;
    color: #000;
  }

  &__link {
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
